// 0 → vazio, 1..5 → escala emoji conforme a nota arredondada.
export const RATING_EMOJIS = ["", "😠", "😕", "😐", "🙂", "🤩"];

export const PERIOD_OPTIONS = [
  { value: 7, label: "7 dias" },
  { value: 30, label: "30 dias" },
  { value: 90, label: "90 dias" },
  { value: 180, label: "180 dias" },
  { value: 365, label: "365 dias" },
];
